<template>
  <section style>
    <div id="mundo">
      <img src="~@/assets/bola_mundo.png" alt />
    </div>
    <div class="columns is-centered">
      <div
        class="column is-5-desktop is-8-tablet is-12-mobile content"
        style="z-index: 1;"
      >
        <b-loading
          :is-full-page="true"
          :active.sync="isLoading"
          :can-cancel="false"
        ></b-loading>
        <div class="section" style="z-index: 3;">
          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="submitRequest">
              <div class="container">
                <b class="is-4 title is-pink">{{
                  $t('Gracias por su información.')
                }}</b>
                <br />
                <b class>
                  {{
                    $t(
                      'Rellene el siguiente formulario para una evaluación inicial del gestor directivo'
                    )
                  }}
                </b>
              </div>
              <hr />

              <b-field expanded :label="`${$t('Nombre')}*`">
                <ValidationProvider
                  :name="$t('Nombre')"
                  rules="required|alpha_spaces"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="garanteeRequestData.name"
                    :placeholder="
                      `${$t('Haga click aqui o pulse para escribir texto')}`
                    "
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>

              <b-field
                expanded
                :label="`${$t('Breve descripcion de tu negocio')}*`"
              >
                <ValidationProvider
                  :name="$t('Nombre')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="garanteeRequestData.description"
                    maxlength="500"
                    type="textarea"
                    :placeholder="
                      `${$t('Haga click aqui o pulse para escribir texto')}`
                    "
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>
              <b-field grouped group-multiline class="">
                <b-field expanded :label="`${$t('Importe de garantia')}*`">
                  <ValidationProvider
                    :name="$t('Nombre')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="garanteeRequestData.amount"
                      :placeholder="
                        `${$t('Haga click aqui o pulse para escribir texto')}`
                      "
                    ></b-input>
                    <p class="help is-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </b-field>

                <b-field expanded :label="`${$t('Plazo')}*`">
                  <ValidationProvider
                    :name="$t('Nombre')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="garanteeRequestData.deadline"
                      :placeholder="
                        `${$t('Haga click aqui o pulse para escribir texto')}`
                      "
                    ></b-input>
                    <p class="help is-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </b-field>
              </b-field>
              <b-field expanded :label="`${$t('Beneficiario')}*`">
                <ValidationProvider
                  :name="$t('Nombre')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="garanteeRequestData.beneficiary"
                    :placeholder="
                      `${$t('Haga click aqui o pulse para escribir texto')}`
                    "
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>

              <hr />
              <div class="container" style="margin-top: 30px;">
                <b class>
                  {{
                    $t(
                      'Necesitamos una dirección de email para enviar la evaluación inicial.'
                    )
                  }}
                </b>
                <b-field addons position="is-centered">
                  <ValidationProvider
                    :name="$t('email')"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="email"
                      style="font-size: normal;"
                      maxlength="50"
                      :placeholder="$t('Escribe tu email')"
                    />
                    <p class="help is-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                  <button
                    :disabled="invalid"
                    native-type="submit"
                    class="button is-primary"
                  >
                    {{ $t('Finalizar') }}
                  </button>
                </b-field>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'
//import SuccessModal from '@/components/on-board/SuccessModal'
import { required, email } from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('email', {
  ...email
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mixins: [EnumeratesFormater, Fetcher, OnBoardStepMixin],
  data() {
    return {
      email: '',
      garanteeRequestData: {
        name: null,
        description: null,
        amount: null,
        deadline: null,
        beneficiary: null
      }
    }
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData']),
    ...mapGetters('user', ['userId', 'userEmail', 'parentRef'])
  },
  mounted() {
    try {
      const emptyFields = Object.values(this.neofintechData.phase1).filter(
        element => element.length == 0
      ).length
      if (emptyFields > 1) {
        this.$router.push({
          name: 'onBoard.neofintech.phase1.1'
        })
      }
    } catch (e) {
      this.$router.push({
        name: 'onBoard.neofintech.phase1.1'
      })
    }
  },
  methods: {
    ...mapActions('onBoard', ['postNewOnboardRequest']),
    submitRequest: function() {
      let self = this
      self.request(() =>
        self
          .postNewOnboardRequest({
            phase1: self.neofintechData.phase1,
            lang: self.$i18n.locale,
            email: self.email,
            responsible: self.userEmail,
            GSI1SK: self.parentRef + self.userId,
            garanteeRequestData: self.garanteeRequestData
          })
          .then(function(response) {
            self.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
            self.$router.push({
              name: 'onBoard.neofintech.phase1.status',
              params: { id: response.GSI1SK }
            })
            /*
            self.$dlg.modal(SuccessModal, {
              shaking: false,
              title: false,
              params: {
                title: self.$t('Gracias por su información'),
                bgColor: '#de4281',
                content: `<p>${self.$t(
                  'Para continuar, revise la bandeja de entrada de su email, le hemos enviado la evaluación inicial.'
                )}</p>`,
                confirmText: self.$t('Aceptar')
              },
              callback: () => {
                self.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
                self.$router.push({
                  name: 'onBoard.neofintech.phase1.status',
                  params: { id: response.GSI1SK }
                })
              }
            })
            */
          })
      )
    }
  }
}
</script>

<style lang="scss">
.flex-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
}
#mundo {
  position: fixed;
  top: 60;
  right: -100px;
  width: 60vh;
  z-index: 0;
  pointer-events: none;
}
.field.has-addons.has-addons-centered span {
  flex-grow: 1;
}

@media (max-width: 768px) {
  #mundo {
    opacity: 0.1;
  }
}
</style>
